import { c as _c } from "react/compiler-runtime";
import { translateInline } from '@/globals/translate/translateInline';
import { classes } from '@/uiPrimitives/base/classes.helpers';
import { textBlock } from '@/uiPrimitives/typography/text';
export const NoResults = () => {
  const $ = _c(1);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = <p className={classes(textBlock({
      fontStyle: "italic"
    }))}>{translateInline({
        en: "No results found",
        nl: "Geen resultaten gevonden"
      })}</p>;
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  return t0;
};